let API_ROOT, APP_ROOT, STORE_ROOT, RESULTS_ROOT, WWW_ROOT, EH_ROOT;

const ENVIRONMENTS = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  QA: 'qa',
  PREVIEW: 'preview',
  LOCAL: 'local',
};

switch (process.env.REACT_APP_ENV) {
  case ENVIRONMENTS.PRODUCTION:
    API_ROOT = 'https://secure.everlywell.com/aapi';
    APP_ROOT = 'https://www.everlywell.com';
    STORE_ROOT = 'https://secure.everlywell.com';
    RESULTS_ROOT = 'https://results.everlywell.com';
    WWW_ROOT = 'https://www.everlywell.com';
    EH_ROOT = 'https://www.everlyhealth.com';
    break;
  case ENVIRONMENTS.STAGING:
    API_ROOT = 'https://secure-staging.everlywell.com/aapi';
    APP_ROOT = 'https://staging.everlywell.com';
    STORE_ROOT = 'https://secure-staging.everlywell.com';
    RESULTS_ROOT = 'https://results-staging.everlywell.com';
    WWW_ROOT = 'https://staging.everlywell.com';
    EH_ROOT = 'https://staging.everlyhealth.com';
    break;
  case ENVIRONMENTS.PREVIEW:
    API_ROOT = 'https://v0-3-580.secure-gitlab-preview.everlywell.com/aapi';
    APP_ROOT = 'https://v0-3-580.everlywell.com';
    STORE_ROOT = 'https://v0-3-580.secure-gitlab-preview.everlywell.com';
    RESULTS_ROOT = 'https://v0-3-580.results-preview.everlywell.com';
    WWW_ROOT = 'https://everlywell.com';
    EH_ROOT = 'https://v0-3-580.everlyhealth.com';
    break;
  case ENVIRONMENTS.QA:
    API_ROOT = 'https://secure-qa.everlywell.com/aapi';
    APP_ROOT = 'https://qa.everlywell.com';
    STORE_ROOT = 'https://secure-qa.everlywell.com';
    RESULTS_ROOT = 'https://results-qa.everlywell.com';
    WWW_ROOT = 'https://qa.everlywell.com';
    EH_ROOT = 'https://qa.everlyhealth.com';
    break;
  case ENVIRONMENTS.LOCAL:
    API_ROOT = process.env.API_ROOT || 'http://localhost:3000/aapi';
    APP_ROOT = process.env.PUBLIC_APP_ROOT || '';
    STORE_ROOT = process.env.API_ROOT || 'http://localhost:3000';
    RESULTS_ROOT = 'http://localhost:3001';
    WWW_ROOT = 'http://localhost:8080';
    EH_ROOT = 'http://localhost:8100';
    break;
  default:
    API_ROOT = 'https://secure-qa.everlywell.com/aapi';
    APP_ROOT = 'http://localhost:8200';
    STORE_ROOT = 'https://secure-qa.everlywell.com';
    RESULTS_ROOT = 'https://results-qa.everlywell.com';
    WWW_ROOT = 'https://qa.everlywell.com';
    EH_ROOT = 'https://everlyhealth.com';
}

const CONTENTFUL_ROOT = 'https://cdn.contentful.com:443';

module.exports = {
  API_ROOT,
  APP_ROOT,
  STORE_ROOT,
  CONTENTFUL_ROOT,
  RESULTS_ROOT,
  ENVIRONMENTS,
  WWW_ROOT,
  EH_ROOT,
};
